import { MODULE_I18_PREFIX } from '../config/i18.luci';

export const CHARGEBACKS_TABLE_I18_PREFIX =
  `${MODULE_I18_PREFIX}.chargebacks.table` as const;
export const CHARGEBACKS_FINAL_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.final.tabs` as const;
export const CHARGEBACKS_MAIN_TABS = {
  NEW: 'new',
  IN_PROGRESS: 'in-progress',
  FINAL: 'final'
} as const;
export const CHARGEBACKS_PROGRESS_TABS = {
  DISPUTE: 'dispute',
  PROCESSING: 'processing'
} as const;
export const CHARGEBACKS_FINAL_TABS = {
  LOSS: 'loss',
  RECOVERED: 'recovered'
} as const;
// chargebacks
export const CHARGEBACKS_MAIN_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.chargebacks.mainTabs` as const;
export const CHARGEBACKS_TABS_I18_PREFIX =
  `${MODULE_I18_PREFIX}.chargebacks.tabs` as const;
